module.exports = __webpack_public_path__ + "img/25_20.2b6e43a3.png";